// export async function fetchConfigClient() {
//   try {
//     // First try to fetch from local JSON in public folder
//     const response = await fetch("/data/version.json", {
//       cache: "no-store",
//     });

//     if (response.ok) {
//       const data = await response.json();
//       console.log("Loaded config from local JSON:", data);
//       return data;
//     }

//     // If local fails, try to fetch from server URL (for production)
//     const serverUrl =
//       process.env.REACT_APP_CONFIG_URL ||
//       process.env.NEXT_PUBLIC_CONFIG_URL;
//     if (serverUrl) {
//       const serverResponse = await fetch(serverUrl, {
//         cache: "no-store",
//       });

//       if (serverResponse.ok) {
//         const data = await serverResponse.json();
//         console.log("Loaded config from server:", data);
//         return data;
//       }
//     }

//     console.error("Failed to fetch config from both local and server");
//     return null;
//   } catch (error) {
//     console.error("Error fetching config:", error);
//     return null;
//   }
// }





const REMOTE_URL = "https://www.dewaapproval.ae/bloghtml.json";
const LOCAL_URL = "/data/version.json"; // must be inside public/data

export async function fetchConfigClient(){
  try {
    const url =
      process.env.NODE_ENV === "development"
        ? LOCAL_URL
        : REMOTE_URL;

    const res = await fetch(url, {
      cache: "no-store",
    });

    if (!res.ok) throw new Error(`Failed: ${res.status}`);

    return (await res.json());
  } catch (err) {
    console.error("[config] client fetch error:", err);
    return {};
  }
}